var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65438 21.1029L1.9923 21.3282C2.64937 21.7662 3.4214 22 4.2111 22H19.7889C20.5786 22 21.3506 21.7662 22.0077 21.3282L22.3456 21.1029C23.3792 20.4139 24 19.2539 24 18.0117C24 17.3493 23.8229 16.6989 23.4871 16.128L15.014 1.72387C14.3858 0.6558 13.2392 0 12 0C10.7608 0 9.61423 0.6558 8.98596 1.72387L0.512943 16.128C0.177095 16.6989 0 17.3493 0 18.0117C0 19.2539 0.620815 20.4139 1.65438 21.1029ZM13 14L14 5H10L11 14H13ZM14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18Z",
    fill: "#E63F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/Exclamation-Triangle.48245e34f0ae83ab3214b64da63f8c54.svg";
export { ForwardRef as ReactComponent };